import { Dispatch } from 'redux';
import { errorService } from '../services/userAPI';
import { ErrorReport } from '../types/common';
import { formatApiErrorPayload } from './utils';

export const REPORT_ERROR = 'REPORT_ERROR';
export const REPORT_ERROR_OK = 'REPORT_ERROR_OK';
export const REPORT_ERROR_ERROR = 'REPORT_ERROR_ERROR';

export const reportError = (error: ErrorReport) => async (dispatch: Dispatch) => {
  dispatch({ type: REPORT_ERROR });

  const response = await errorService.reportError(error);
  if (response.ok) {
    dispatch({
      type: REPORT_ERROR_OK,
      data: response.data,
    });
  } else {
    dispatch({
      ...formatApiErrorPayload(response),
      type: REPORT_ERROR_ERROR,
    });
  }

  return response;
};
